import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { JobListingModel } from '../../views/jobs/model/job_listing_model';
import { JobApplicationModel } from '../../views/jobs/model/job_application_model';

interface ConfirmationDialogProps {
  open: boolean;
  selectedItem: JobListingModel |JobApplicationModel | undefined;
  bodyContent:string;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ open, onClose, onConfirm,bodyContent, selectedItem }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Action</DialogTitle>
      <DialogContent>
        <p>{bodyContent}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
